// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPcp {
    static getAttributeTypeMap() {
        return MedicalBiPcp.attributeTypeMap;
    }
}
MedicalBiPcp.discriminator = undefined;
MedicalBiPcp.additionalProperties = false;
MedicalBiPcp.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPcp.js.map